export default __webpack_public_path__ + "static/media/hht1_ep16_timeline_q03_b.a47009a8.png";